import initSwipers from "../swiper/initSwipers";
import initGlightbox from "./initGlightbox";
import currencySwitcher from "./currencySwitcher";

export default function kobleQuickView() {
    const triggers = document.querySelectorAll(
        '[data-bs-target="#modal_quick-view"]'
    );

    triggers?.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            // e.stopPropagation();
        });
    });

    document.addEventListener(
        "quickviewSuccess",
        () => {
            initSwipers();
            initGlightbox();
            currencySwitcher();
        },
        false
    );
}
